import {
  Activity,
  BookOpen,
  Boxes,
  BriefcaseBusiness,
  CalendarDays,
  ChartNoAxesColumnIncreasing,
  CircleHelp,
  Clock3,
  Cloud,
  Database,
  ExternalLink,
  FileSignature,
  FileText,
  FolderKanban,
  Headphones,
  House,
  KeyRound,
  LayoutDashboard,
  LifeBuoy,
  ListChecks,
  Mail,
  MessageSquare,
  PackageSearch,
  Settings,
  ShieldCheck,
  UsersRound,
  Wrench,
  Workflow,
} from '@lucide/vue'
import type { Component } from 'vue'
import type { LUCIDE_ICON_NAMES } from '~~/shared/schemas/common'

type LucideIconName = (typeof LUCIDE_ICON_NAMES)[number]

export const lucideIconComponents = {
  activity: Activity,
  'book-open': BookOpen,
  boxes: Boxes,
  'briefcase-business': BriefcaseBusiness,
  'calendar-days': CalendarDays,
  'chart-no-axes-column-increasing': ChartNoAxesColumnIncreasing,
  'circle-help': CircleHelp,
  'clock-3': Clock3,
  cloud: Cloud,
  database: Database,
  'external-link': ExternalLink,
  'file-signature': FileSignature,
  'file-text': FileText,
  'folder-kanban': FolderKanban,
  headphones: Headphones,
  house: House,
  'key-round': KeyRound,
  'layout-dashboard': LayoutDashboard,
  'life-buoy': LifeBuoy,
  'list-checks': ListChecks,
  mail: Mail,
  'message-square': MessageSquare,
  'package-search': PackageSearch,
  settings: Settings,
  'shield-check': ShieldCheck,
  'users-round': UsersRound,
  wrench: Wrench,
  workflow: Workflow,
} satisfies Record<LucideIconName, Component>
